<script setup>
import CapaCalender from "@/views/quality/capa-calender/index.vue"

definePage({
  meta: {
    name: "capa-calender",
    subject: 'quality.menu',
    action: 'capa_calender',
  },
})
</script>

<template>
  <CapaCalender />
</template>
